import React from 'react';
import VstComponent from './VstComponent';
import addClassName from '../utils/add-class-name';
import copyProps from '../utils/copy-props';
import classNames from 'classnames';
import namespaceOptions from '../utils/namespace-options';
import { css } from 'glamor';

class VstButton extends VstComponent {

  _getCSS() {
    return {
      backgroundColor: this._theme(7),
      borderColor: this._theme(7),
      ':hover': {
        backgroundColor: this._theme(8),
        borderColor: this._theme(8)
      }
    };
  }

  render() {
    const rule = css(this._getCSS());

    let props = addClassName(this.props, classNames(namespaceOptions('vst', this.props.options), 'vst-button', rule.toString()));
    props = copyProps(props, ['options']);

    return (
      <button {...props}>{this.props.children}</button>
    );
  }
}

export default VstButton;
